import i18n from 'config/i18n';
import * as yup from 'yup';

import { getLocale } from 'utils/date';
import { stringToFloat } from 'utils/misc';
import { Dayjs } from 'dayjs';

const getSchema = () => {
  const t = i18n.getFixedT(getLocale(), 'common');

  return yup
    .object({
      description: yup
        .string()
        .required(t('validationFieldRequired', { name: t('description') })),
      hoursPerWeek: yup
        .number()
        .required(t('validationFieldRequired', { name: t('hoursPerWeek') }))
        .transform(stringToFloat)
        .typeError(t('enterAValidNumericValue')),
      startDate: yup
        .mixed<Dayjs>()
        .required(t('validationFieldRequired', { name: t('startDate') })),
      endDate: yup
        .mixed<Dayjs>()
        .nullable()
        .required(t('validationFieldRequired', { name: t('endDate') })),
      function: yup
        .mixed()
        .required(t('validationFieldRequired', { name: t('function') })),
      organizationalUnit: yup
        .mixed()
        .required(t('validationFieldRequired', { name: t('planUnit') }))
    })
    .required();
};

export default getSchema;
